import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';

const NICOLE_AVATAR = 'https://cdn.pawnec.com/petpulse/Vetscribe%20AI%20-%2003%20Clinic%20Data%20Analyst%20Avatar.gif';

function NicoleToast({ visible, message, onClose, autoHideMs = 5000 }) {
  useEffect(() => {
    if (!visible || !autoHideMs) return;
    const timer = setTimeout(onClose, autoHideMs);
    return () => clearTimeout(timer);
  }, [visible, autoHideMs, onClose]);

  if (!visible) return null;

  return ReactDOM.createPortal(
    <div className="fixed top-4 right-4 z-[200] w-80 animate-slideIn">
      <div
        className="rounded-2xl p-[2px]"
        style={{ background: 'linear-gradient(90deg, #a8e6cf, #88d8f7, #ffd3b6, #ffaaa5, #f8b4d9)' }}
      >
        <div className="bg-white rounded-2xl px-4 py-3.5 flex items-start gap-3 shadow-lg">
          <img
            src={NICOLE_AVATAR}
            alt="Nicole"
            className="h-9 w-9 rounded-full object-cover flex-shrink-0 mt-0.5"
          />
          <div className="flex-1 min-w-0">
            <p
              className="text-[13px] font-bold leading-tight"
              style={{
                background: 'linear-gradient(90deg, #e8a87c, #d4a05a, #c0a040, #85b79d, #66a5ad)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {message || 'Nicole is preparing your export'}
            </p>
            <p className="text-xs text-gray-500 mt-1 leading-snug">
              It will be sent to your email address once ready.
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 flex-shrink-0 mt-0.5 transition-colors"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default NicoleToast;
